import React, { useState } from "react";
import {
  Avatar,
  Container,
  Card,
  Typography,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { apiLogout } from "../services/auth.service";
import { parseEmail } from "../utils/tableFunctions";
import { APP_USER_SESSION } from "../constant/AppConstants";
import * as StorageUtils from "../utils/storageUtils";
import { Logger } from "../utils/logger";
import { Edit } from "@mui/icons-material";

const Profile = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

  return (
    <Container>
      <Stack spacing={5} direction="column">
        <Card
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: 2,
          }}
        >
          <IconButton
            color="primary"
            style={{ alignSelf: "flex-end" }}
            onClick={handleDialogOpen}
          >
            <LogoutIcon />
          </IconButton>
          <Dialog open={openDialog} onClose={handleDialogClose}>
            <DialogTitle>{"Are you sure you want to log out?"}</DialogTitle>
            <DialogActions>
              <Button variant="contained" color="error" onClick={apiLogout}>
                Log Out
              </Button>
              <Button variant="contained" onClick={handleDialogClose}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Stack spacing={2} direction="column" sx={{ alignItems: "center" }}>
            <Avatar
              src={"https://cdn-icons-png.flaticon.com/512/3135/3135789.png"}
              alt="photoURL"
              sx={{ width: 70, height: 70 }}
            />
            <Typography variant="h5">
              {parseEmail(userSession.user.email)}
            </Typography>
            {/* {loaded && <Typography>{details.role.role}</Typography>} */}
          </Stack>
        </Card>

        <Card
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            p: 2,
          }}
        >
          <Button
            variant="outlined"
            sx={{ alignSelf: "flex-end" }}
            onClick={() => {
              apiLogout();
            }}
            endIcon={<Edit />}
          >
            Change Password
          </Button>
          <Table
            sx={{
              borderColor: "transparent",
              maxWidth: "400px",
            }}
          >
            <TableBody>
              <TableRow>
                <TableCell align="right">
                  <strong>Username</strong>
                </TableCell>
                <TableCell align="left">
                  {parseEmail(userSession.user.email)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">
                  <strong>Email</strong>
                </TableCell>
                <TableCell align="left">{userSession.user.email}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </Stack>
    </Container>
  );
};

export default Profile;
